module.exports = __webpack_public_path__ + "static/img/huai3.ef51386.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/huai3.jpg
// module id = WhtN
// module chunks = 0